import { Alert, Grid, Link, Stack } from "@mui/material";
import ActionLoader from "components/UI/ActionLoader";
import React, { useCallback, useEffect, useState } from "react";
import { useQuery } from "react-query";
import MenuItem from "../MenuItem";
import { Feature } from "models/api";
import { fetchServices } from "framework/services";
import Logo from "components/Logo";
import { useTranslation } from "react-i18next";
import { getAllPermission, getUserData } from "helpers";
import { IPermission } from "models/permissions";

interface Props {}

export const viewable = (role: string, roles: string[]) => {
  return roles?.includes(role);
};

const SideMenu: React.FC<Props> = () => {
  const userData = getUserData();
  const { colors, roleName } = userData;

  const { t } = useTranslation();
  const [permissions, setPermissions] = useState<IPermission[] | null>(null);
  const { data, isError, isLoading } = useQuery<Feature[]>(
    "features",
    fetchServices
  );
  let user = JSON.parse(localStorage.getItem("profile") || "{}");

  let features: Feature[] | undefined = user.IsAdmin
    ? data
    : data?.filter((feature) => !feature.IsAdmin && !feature?.hidden);
  const [selectedFeature, setSelectedFeature] = React.useState<Feature | null>(
    null
  );

  const fetchPermission = useCallback(async () => {
    try {
      const res = await getAllPermission();
      setPermissions(res);
    } catch (error: any) {}

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchPermission();
    // eslint-disable-next-line
  }, []);

  if (isError)
    return (
      <Alert severity="error">An error occurred while fetching features.</Alert>
    );
  if (isLoading) return <ActionLoader position="fixed" />;

  const handleSelectUnLinkFeature = (feature: Feature) =>
    setSelectedFeature(feature);

  const hasPermission = (feature: Feature) => {
    return (
      permissions?.find(
        (permission) => permission.rolePermissionId === feature.id
      )?.hasReadPermission && viewable(roleName, feature.roles)
    );
  };

  return (
    <Stack
      component={"aside"}
      maxWidth={380}
      bgcolor={colors?.menuBgColor ? colors?.menuBgColor : "sideMenu.bg"}
      zIndex={1200}
      sx={{
        flexShrink: 0,
        position: "sticky",
        top: 0,
        transition: "500ms",
        borderRadius: "0px 10px 10px 0px",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
        p: 1,

        overflowX: "hidden",
        overflowY: "auto",
        display: { xs: "none", lg: "block" },
      }}
    >
      <Stack justifyContent={"center"} spacing={2}>
        <Grid container justifyContent={"center"}>
          <Link href="/">{<Logo />}</Link>
        </Grid>
        {features &&
          features.length > 0 &&
          features.map((feature, index) => {
            if (!hasPermission(feature) && feature.children.length === 0)
              return null;
            return (
              <MenuItem
                currPermissions={permissions}
                onSelectUnLinkFeature={handleSelectUnLinkFeature}
                key={index}
                name={t(feature.name)}
                icon={feature.icon}
                hasChildren={feature.children.length > 0 ? true : false}
                color={"white"}
                feature={feature}
                slug={feature.slug}
                open={true}
              />
            );
          })}
      </Stack>
    </Stack>
  );
};

export default SideMenu;
